import { API } from "@/services/api";
import { IAPIResponse } from "@/services/api.types";
import { compensationEndpoints, reportEndpoints } from "@/constant/endpoints";
import { buildQueryString } from "@/utils/common.utils";
import type { DealCompensation, ProjectedCompensation, ProjectedCompensationParams } from "@/types/compensation.types";

export const getDealCompensationService = async (dealId: string): Promise<DealCompensation> => {
  const response = await API.Get<DealCompensation>(compensationEndpoints.deal(dealId));
  if (response.data) return response.data;
  throw new Error(response.message);
};

export const putDealCompensationService = async (dealId: string, pct: number | null): Promise<IAPIResponse<DealCompensation>> =>
  API.Put<{ pct: number | null }, DealCompensation>(compensationEndpoints.deal(dealId), { pct });

export const getProjectedCompensationService = async (params: ProjectedCompensationParams = {}): Promise<ProjectedCompensation> => {
  const response = await API.Get<ProjectedCompensation>(`${reportEndpoints.projectedCompensation}${buildQueryString(params)}`);
  if (response.data) return response.data;
  throw new Error(response.message);
};
